module.exports = __webpack_public_path__ + "media/v2/components/HowToPlay/img/survive_example-fe4aa86f284736c8a5c0722ea8281f18.png";